module.exports = __webpack_public_path__ + "img/img7.9c50200e.png";